/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Guardrails_EnabledInputs */



/**
* | output |
* | --- |
* | "Guardrails Enabled" |
*
* @param {Private_Models_Form_Guardrails_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_guardrails_enabled = /** @type {((inputs?: Private_Models_Form_Guardrails_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Guardrails_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Guardrails aktiviert")
	return /** @type {LocalizedString} */ ("Guardrails Enabled")
});